
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import actions from '../js/actions.js';
import $$ from 'dom7';
import URLS from '../js/Urls.js';
import moment from 'moment';
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth();
const day = date.getDate();
const today = new Date(year, month, day);
var events = [];
var eventItems;
var GetMonthlyResData;
export default {
  // Lifecycle Hooks
  beforeCreate() {},

  created() {},

  beforeMount() {},

  mounted() {
    app.f7.preloader.hide();
  },

  beforeDestroy() {
    var self = this; //self.calendar.destroy();
  },

  destroyed() {
    var self = this; //self.calendar.destroy();
  },

  // Component Data
  data: function () {
    // Must return an object
    return {
      name: 'Jimmy2',
      age: 25,
      like: ['Tennis', 'Chess', 'Football'],
      eventItems: {},
      GetMonthlyResData: {},
      TotalCheckIns: 0,
      TotalCheckOuts: 0,
      TotalInHouses: 0,
      TotalNigths: 0,
      GroupReservations: {},
      GroupCheckinReservations: {},
      GroupCheckOuteservations: {},
      StayDetailsInfo: {},
      loginobject: {},
      GetInHouseRooms: {},
      Inhouseinfo: {}
    };
  },
  // Component Methods
  methods: {
    openAlert: async function (id) {//  
      //     
      // let $target = $(event.target);
      // let $label = $target.closest('.reservationcardbtn');
      // let resId = $label.attr("id");
    },
    openConversation: function (uID, reservationID) {
      try {
        const obj = {
          uID: uID,
          reservationID: reservationID
        };
        localStorage.setItem("converastion", JSON.stringify(obj));
        app.f7.views.main.router.navigate(`/conversations/`, {
          transition: 'f7-dive'
        });
      } catch (err) {
        console.log(err);
      }
    }
  },
  // Page Events
  on: {
    tabBeforeIn: async function (e, page) {
      let response;
      let $selectedDates = $('.calendar-day-selected');
      let dates = [];
      let uniqueSelectedDates = new Set();
      $selectedDates.each(function (index) {
        let date = $(this).attr('data-date');

        if (date) {
          uniqueSelectedDates.add(date);
        }
      });
      var hasRoomNameCheck = $$("#roomNumberID").html();

      if (hasRoomNameCheck == null || hasRoomNameCheck == "") {
        $$("#roomNumberID").html("NA");
      }

      if ($(".calendar-day-selected").length > 1 && uniqueSelectedDates.size > 1) {
        $(".takis").css("display", "none");
      } else {
        $(".takis").css("display", "block");

        if (uniqueSelectedDates.size === 1) {
          let $target = $(event.target);
          let $date = $target.closest(".calendar-day");
          let [year, month, day] = uniqueSelectedDates.values().next().value.split("-");
          month = parseInt(month) + 1;
          var obj = {
            PropertyID: loginobject.PropertyID,
            UserID: loginobject.UserID,
            Date: [day, month, year].join("-")
          };
        }

        try {
          app.preloader.show();
          await app.request.promise.post(URLS.DailyRes, {
            obj
          }, {
            Date
          }).then(res => {
            self.$setState({
              Inhouseinfo: JSON.parse(res.data)
            });
            app.preloader.hide();
          });
          app.preloader.hide();
        } catch (error) {
          console.log(error);
        }
      }
    },
    tabInit: async function (e, page) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      self.loginobject = actions.LoginGetResult();
      self.$setState({
        loginobject: self.loginobject
      });
      const hasCommunicator = self.loginobject?.Communicator == null ? false : self.loginobject?.Communicator;
      var dateCheck = "";

      if (this.$route.query) {
        dateCheck = this.$route.query.date;
      }

      $$(".searchbar-enable").on("click", async function (e) {
        app.views.main.router.navigate('/search-reservation/', {
          transition: 'f7-dive'
        });
      });
      $$('.subnavbar').hide();

      const renderEvents = calendar => {
        if (calendar && calendar.value[0]) {
          $$("#reservationLastSearchDayValue").val(calendar.value[0].getDate() + "," + calendar.value[0].getMonth() + "," + calendar.value[0].getFullYear());
        }

        var dateArr = $$("#reservationLastSearchDayValue").val().split(',');
        var currentDate = new Date(dateArr[2], dateArr[1], dateArr[0]);
        var TempTotalCheckIns = 0;
        var TempTotalInHouses = 0;
        var TempTotalCheckOuts = 0;
        var TempTotalNigths = 0;
        currentDate.setHours(0, 0, 0, 0);
        var thisDate = currentDate.getTime();
        var currentEvents = events.filter(function (event) {
          event.date.getTime();

          if (event.IsInHouse === true) {
            var startDate = moment(event.ReservationCheckInStr, "DD/MM/YYYY").set({
              hour: 0,
              minute: 0,
              second: 0,
              millisecond: 0
            });
            var endDate = moment(event.ReservationCheckOutStr, "DD/MM/YYYY").set({
              hour: 0,
              minute: 0,
              second: 0,
              millisecond: 0
            });
            var compareDate = moment(thisDate).set({
              hour: 0,
              minute: 0,
              second: 0,
              millisecond: 0
            });
            return compareDate.isBetween(startDate, endDate) || compareDate.isSame(startDate);
          }

          return event.date.getTime() == currentDate.getTime();
        });
        var checkReservationFilter = $("#reservationFilterValue").val();

        if (checkReservationFilter) {
          if (checkReservationFilter == "Not-Assigned") {
            currentEvents = currentEvents.filter(function (event) {
              return event.RoomName == "Do Not Assign";
            });
          } else {
            currentEvents = currentEvents.filter(function (event) {
              return event.ReservationType == checkReservationFilter;
            });
          }
        }

        var currency = actions.GetUserCurrency();
        var eventItemstemp = [];

        if (currentEvents.length) {
          currentEvents.forEach(function (event) {
            if (event.IsCheckIn) {
              TempTotalCheckIns++;
            } else if (event.isInHouse) {
              TempTotalInHouses++;
            } else {
              TempTotalCheckOuts++;
            }

            TempTotalNigths += event.Nights;
            eventItemstemp.push({
              CustomerLastName: event.CustomerLastName,
              CustomerFirstName: event.CustomerFirstName,
              Nights: event.Nights,
              TotalGuests: event.TotalGuests,
              NumberOfRooms: event.NumberOfRooms,
              ArrivalColour: event.ArrivalColour,
              DepartureColour: event.DepartureColour,
              ChannelManagerName: event.ChannelManagerName,
              Source: event.Source,
              ReservationCode: event.ReservationCode,
              TotalPrice: event.TotalPrice,
              RoomName: event.RoomName,
              RoomTypeStr: event.RoomTypeStr,
              color: event.color,
              ReservationID: event.ReservationID,
              ReservationCheckInStr: event.ReservationCheckInStr,
              ReservationCheckOutStr: event.ReservationCheckOutStr,
              IsPaid: event.IsPaid,
              ReservationType: event.ReservationType,
              Currency: currency,
              NewMessages: event.NewMessages,
              ConversationID: event.ConversationID,
              hasCommunicator
            });
          });
        }

        self.$setState({
          eventItems: eventItemstemp,
          TotalNigths: TempTotalNigths,
          TotalCheckIns: TempTotalCheckIns,
          TotalInHouses: TempTotalInHouses,
          TotalCheckOuts: TempTotalCheckOuts
        });
      };

      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      self.calendar = app.calendar.create({
        containerEl: '#reservations-calendar-inline-container',
        value: [new Date()],
        events: [],
        weekHeader: false,
        renderToolbar: function () {
          return '<div class="toolbar calendar-custom-toolbar no-shadow calendarcustomtoolbar">' + '<div class="toolbar-inner">' + '<div class="left">' + '<a href="#" class="link icon-only"><i class="icon icon-back ' + (app.theme === 'md' ? 'color-black' : '') + '"></i></a>' + '</div>' + '<div class="center"></div>' + '<div class="right">' + '<a href="#" class="link icon-only"><i class="icon icon-forward ' + (app.theme === 'md' ? 'color-black' : '') + '"></i></a>' + '</div>' + '</div>' + '</div>';
        },
        on: {
          open: function (c) {
            var MyDate = c.value[0].getFullYear() + '-' + (c.value[0].getMonth() + 1) + '-' + c.value[0].getDate();
            Getdata(MyDate);

            if (dateCheck) {
              GetDailyData(dateCheck.replaceAll('/', '-'));
            } else {
              GetDailyData();
            }
          },
          init: function (c) {
            $$("#calendar-events").on('click', ".reservationcardbtn", async function (event) {
              let $target = $(event.target);
              let $label = $target.closest('.reservationcardbtn').find('.reservcode');
              let ReservationID = $label.attr("id");
              var obj = {
                PropertyID: loginobject.PropertyID,
                UserID: loginobject.UserID,
                ReservationID: ReservationID
              };

              try {
                app.preloader.show();
                localStorage.setItem("ReservationID", JSON.stringify(ReservationID));
                app.views.main.router.navigate('/reservation-info/', {
                  transition: 'f7-dive'
                });
                app.preloader.hide();
              } catch (error) {
                console.log(error);
              }
            });

            if (dateCheck) {
              var tmpDateCheck = dateCheck.split('/');
              var dateObject = new Date(tmpDateCheck[2] + '-' + tmpDateCheck[1] + '-' + tmpDateCheck[0]);
              c.value[0] = dateObject;
            }

            renderEvents(c);
            $('.calendar-custom-toolbar .center').text(monthNames[c.currentMonth] + ', ' + c.currentYear);
            $('.calendar-custom-toolbar .left .link').on('click', function () {
              c.prevMonth();
            });
            $('.calendar-custom-toolbar .right .link').on('click', function () {
              c.nextMonth();
            });
            var loginobject = actions.LoginGetResult();
            $$('.searchId').on('change', async function () {
              let query = $('.searchId').val();
              const UserSpecificApiKey = loginobject?.PropertiesList?.find(property => property.PropertyName == loginobject?.PropertyName)?.UserSpecificApiKey;
              var obj = {
                PropertyID: loginobject.PropertyID,
                UserID: loginobject.UserID,
                query: query,
                UserSpecificApiKey: UserSpecificApiKey
              };

              try {
                let response = await app.f7.request.promise.postJSON(URLS.SearchForReservation, {
                  obj
                });
                self.$setState({
                  FindReservation: response.data
                });
                localStorage.setItem("SelectedReservation", JSON.stringify(response.data));
              } catch (error) {
                console.log(error);
              }

              app.f7.views.main.router.navigate('/search-reservation/', {
                transition: 'f7-dive'
              });
            });
            $$('.reservationcardbtn').on('click', function (event) {
              let $target = $(event.target);
              let $class = $target.closest('.reservcode');
              var reservId = $class.attr("id");
              app.f7.views.main.router.navigate('/main/reservation-info/', {
                transition: 'f7-dive'
              });
            });
          },
          monthYearChangeStart: function (c) {
            $('.calendar-custom-toolbar .center').text(monthNames[c.currentMonth] + ', ' + c.currentYear);
            var MyDate = c.value[0].getFullYear() + '-' + (c.currentMonth + 1) + '-' + c.value[0].getDate();
            Getdata(MyDate, c);
            GetDailyData();
          }
        }
      });
      self.calendar.on('dayClick', myHandler2);

      function myHandler2(calendar, dayEl, year, month, day) {
        calendar.setValue([new Date(year, month, day)]);
        renderEvents(calendar);
        GetDailyData();
      }

      async function Getdata(date, c) {
        var ResponseGetMonthlyResData = {};
        ResponseGetMonthlyResData = await actions.GetMonthlyResData(date);
        events = [];
        ResponseGetMonthlyResData.forEach(function (item, index) {
          var re = /-?\d+/;
          var m = re.exec(item.ReservationCheckIn);
          var d = new Date(parseInt(m[0]));
          var isInHouseCheck = false;

          if (item.CheckedinDatetime) {
            isInHouseCheck = true;
          }

          if (item.CheckedoutDatetime) {
            isInHouseCheck = false;
          }

          var ReservationType1 = "Arrival";

          if (item.CheckedinDatetime) {
            ReservationType1 = "In-House";
          } else if (item.RoomName == "NA") {
            ReservationType1 = "Not-Assigned";
          }

          var currency = actions.GetUserCurrency();
          var obj = {
            date: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
            // hours: 21,
            // minutes: 0,
            CustomerLastName: item.CustomerLastName,
            CustomerFirstName: item.CustomerFirstName,
            Nights: item.Nights,
            TotalGuests: item.TotalGuests,
            NumberOfRooms: item.NumberOfRooms,
            ChannelManagerName: item.ChannelManagerName,
            Source: item.Source,
            IsCheckIn: item.CheckedinDatetime ? false : true,
            ReservationCode: item.ReservationCode,
            TotalPrice: item.TotalPrice,
            RoomName: item.RoomName,
            RoomTypeStr: item.RoomTypeStr,
            color: item.ArrivalColour,
            // color: "black",
            ReservationID: ResponseGetMonthlyResData[index].ReservationID,
            ReservationCheckInStr: item.ReservationCheckInStr,
            ReservationCheckOutStr: item.ReservationCheckOutStr,
            IsPaid: item.isPaid,
            ReservationType: ReservationType1,
            CheckedinDatetime: item.CheckedinDatetime,
            IsInHouse: isInHouseCheck ? true : false,
            Currency: currency,
            NewMessages: item.NewMessages,
            ConversationID: item.ConversationID
          };
          var re = /-?\d+/;
          var m = re.exec(item.ReservationCheckOut);
          var d = new Date(parseInt(m[0]));
          var ReservationType2 = "Departure";

          if (item.CheckedinDatetime) {
            ReservationType2 = "In-House";
          } else if (item.RoomName == "NA") {
            ReservationType2 = "Not-Assigned";
          }

          var obj2 = {
            date: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
            // hours: 21,
            // minutes: 0,
            CustomerLastName: item.CustomerLastName,
            CustomerFirstName: item.CustomerFirstName,
            Nights: item.Nights,
            TotalGuests: item.TotalGuests,
            NumberOfRooms: item.NumberOfRooms,
            ChannelManagerName: item.ChannelManagerName,
            Source: item.Source,
            IsCheckIn: false,
            ReservationCode: item.ReservationCode,
            TotalPrice: item.TotalPrice,
            RoomName: item.RoomName,
            RoomTypeStr: item.RoomTypeStr,
            color: item.DepartureColour,
            // color:"yellow",
            ReservationID: ResponseGetMonthlyResData[index].ReservationID,
            ReservationCheckInStr: item.ReservationCheckInStr,
            ReservationCheckOutStr: item.ReservationCheckOutStr,
            IsPaid: item.isPaid,
            ReservationType: ReservationType2,
            CheckedinDatetime: item.CheckedinDatetime,
            Currency: currency,
            NewMessages: item.NewMessages,
            ConversationID: item.ConversationID //IsInHouse: item.CheckedinDatetime ? true : false

          };
          events.push(obj);
          events.push(obj2);
        });
        self.calendar.params.events = events;
        self.calendar.update();
        renderEvents(self.calendar); // var date = new Date();
        // if (c != null) {
        //   var y = date.getFullYear();
        //   var m = date.getMonth();
        // } else {
        //   var y = date.getFullYear();
        //   var m = date.getMonth();
        // }
        // var firstDay = new Date(y, m, 1);
        // var lastDay = new Date(y, m + 1, 0);
        // var filteredbyReservationckin = ResponseGetMonthlyResData.filter(function (item) {
        //   var re = /-?\d+/;
        //   var m = re.exec(item.ReservationCheckIn);
        //   var d = new Date(parseInt(m[0]));
        //   return d >= firstDay && d <= lastDay;
        // });
        // var filteredbyBooking = ResponseGetMonthlyResData.filter(function (item) {
        //   var re = /-?\d+/;
        //   var m = re.exec(item.ReservationBookingDate);
        //   var d = new Date(parseInt(m[0]));
        //   return d >= firstDay && d <= lastDay;
        // });
        // var ReservationsByDate = _.chain(filteredbyBooking)
        //   // Group the elements of Array based on `color` property
        //   .groupBy("ReservationBookingDayStr")
        //   // `key` is group's name (color), `value` is the array of objects
        //   .map((value, key) => ({ ReservationBookingDayStr: key, Reservations: value }))
        //   .value();
        // ReservationsByDate = _.sortBy(ReservationsByDate, 'ReservationBookingDayStr');
        // ReservationsByDate.map(function (group) {
        //   const reservations = group.Reservations;
        //   const DateStr = group.ReservationBookingDayStr;
        //   return reservations.map(function (reservation) {
        //     if (DateStr === reservation.ReservationCheckInStr) {
        //       reservation.color = reservation.ArrivalColour;
        //     }
        //     else if (DateStr === reservation.ReservationCheckOutStr) {
        //       reservation.color = reservation.DepartureColour;
        //     }
        //     return reservation;
        //   })
        // });
        // var ReservationsByCheckInDate = _.chain(filteredbyReservationckin)
        //   // Group the elements of Array based on `color` property
        //   .groupBy("ReservationCheckInStr")
        //   // `key` is group's name (color), `value` is the array of objects
        //   .map((value, key) => ({ ReservationCheckInStr: key, Reservations: value }))
        //   .value();
        // ReservationsByCheckInDate = _.sortBy(ReservationsByCheckInDate, 'ReservationCheckInStr');
        // ReservationsByCheckInDate.map(function (group) {
        //   const reservations = group.Reservations;
        //   const DateStr = group.ReservationCheckInStr;
        //   return reservations.map(function (reservation) {
        //     if (DateStr === reservation.ReservationCheckInStr) {
        //       reservation.color = reservation.ArrivalColour;
        //     }
        //     else if (DateStr === reservation.ReservationCheckOutStr) {
        //       reservation.color = reservation.DepartureColour;
        //     }
        //     return reservation;
        //   })
        // });

        var date = new Date();

        if (c != null) {
          var y = date.getFullYear();
          var m = date.getMonth();
        } else {
          var y = date.getFullYear();
          var m = date.getMonth();
        }

        var firstDay = new Date(y, m, 1);
        var lastDay = new Date(y, m + 1, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        var currency = actions.GetUserCurrency();

        var ReservationsByDate = _.chain(ResponseGetMonthlyResData).filter(function (item) {
          var re = /-?\d+/;
          var m = re.exec(item.ReservationCheckIn);
          var d = new Date(parseInt(m[0], 10));
          return d >= today;
        }).groupBy("ReservationBookingDayStr").map((value, key) => ({
          ReservationBookingDayStr: key,
          Reservations: value
        })).orderBy([group => moment(group.ReservationBookingDayStr, 'DD/MM/YYYY').toDate(), 'desc'], ['desc']).map(function (group) {
          const reservations = group.Reservations;
          const DateStr = group.ReservationBookingDayStr;
          return {
            ReservationBookingDayStr: DateStr,
            Reservations: reservations.map(function (reservation) {
              if (DateStr === reservation.ReservationCheckInStr) {
                reservation.color = reservation.ArrivalColour;
              } else if (DateStr === reservation.ReservationCheckOutStr) {
                reservation.color = reservation.DepartureColour;
              }

              reservation.Currency = currency;
              return reservation;
            })
          };
        }).value();

        var ReservationsByCheckInDate = _.chain(ResponseGetMonthlyResData).filter(function (item) {
          var re = /-?\d+/;
          var m = re.exec(item.ReservationCheckIn);
          var d = new Date(parseInt(m[0], 10));

          if (isNaN(d.getTime())) {
            console.error('Invalid date for item:', item);
            return false;
          }

          return d >= firstDay || d.getMonth() === m && d <= lastDay;
        }).groupBy("ReservationCheckInStr").map((value, key) => ({
          ReservationCheckInStr: key,
          Reservations: value
        })).orderBy('ReservationCheckInStr', 'desc').filter(group => {
          // Convert the date string to "MM/DD/YYYY" format before creating the Date object
          const groupDate = new Date(group.ReservationCheckInStr.split('/').reverse().join('/'));

          if (isNaN(groupDate.getTime())) {
            console.error('Invalid date for group:', group);
            return false;
          }

          groupDate.setHours(0, 0, 0, 0);
          return groupDate >= today;
        }).value();

        var ReservationsByCheckOutDate = _.chain(ResponseGetMonthlyResData).filter(function (item) {
          var re = /-?\d+/;
          var m = re.exec(item.ReservationCheckOut);
          var d = new Date(parseInt(m[0], 10));

          if (isNaN(d.getTime())) {
            console.error('Invalid date for item:', item);
            return false;
          }

          return d >= firstDay || d.getMonth() === m && d <= lastDay;
        }).filter(function (item) {
          // Add a condition to check if CheckedinDatetime is not null
          return item.CheckedinDatetime != null;
        }).groupBy("ReservationCheckOutStr").map((value, key) => ({
          ReservationCheckOutStr: key,
          Reservations: value
        })).orderBy('ReservationCheckOutStr', 'desc').filter(group => {
          // Convert the date string to "MM/DD/YYYY" format before creating the Date object
          const groupDate = new Date(group.ReservationCheckOutStr.split('/').reverse().join('/'));

          if (isNaN(groupDate.getTime())) {
            console.error('Invalid date for group:', group);
            return false;
          }

          groupDate.setHours(0, 0, 0, 0);
          return groupDate >= today;
        }).value();

        self.$setState({
          GetMonthlyResData: ResponseGetMonthlyResData,
          GroupReservations: ReservationsByDate,
          GroupCheckinReservations: ReservationsByCheckInDate,
          GroupCheckOuteservations: ReservationsByCheckOutDate
        });
      }

      async function GetDailyData(tmpDate) {
        // var $ = self.$;
        var loginobject = actions.LoginGetResult();
        let response;
        let $selectedDates = $('.calendar-day-selected');
        let dates = [];
        let uniqueSelectedDates = new Set();
        const UserSpecificApiKey = loginobject?.PropertiesList?.find(property => property.PropertyName == loginobject?.PropertyName)?.UserSpecificApiKey;
        $selectedDates.each(function (index) {
          let date = $(this).attr('data-date');

          if (date) {
            uniqueSelectedDates.add(date);
          }
        });

        if ($(".calendar-day-selected").length > 1 && uniqueSelectedDates.size > 1) {
          $(".takis").css("display", "none");
        } else {
          $(".takis").css("display", "block");

          if (uniqueSelectedDates.size === 1) {
            let $target = $(event.target);
            let $date = $target.closest(".calendar-day");
            let [year, month, day] = uniqueSelectedDates.values().next().value.split("-");
            month = parseInt(month) + 1;
            var obj = {
              PropertyID: loginobject.PropertyID,
              UserID: loginobject.UserID,
              Date: [day, month, year].join("-"),
              UserSpecificApiKey: UserSpecificApiKey
            };
          }

          if (tmpDate) {
            obj.Date = tmpDate;
          }

          try {
            app.preloader.show();
            await app.request.promise.post(URLS.DailyRes, {
              obj
            }, {
              Date
            }).then(res => {
              self.$setState({
                Inhouseinfo: JSON.parse(res.data)
              });
              app.preloader.hide();
            });
            app.preloader.hide();
          } catch (error) {
            console.log(error);
          }
        }
      }

      async function FilterReservations(ID, Type) {
        var el = $$("#" + ID);
        var type = Type;

        if (el.hasClass("activeFilter")) {
          // kane reset cookie me to filter
          el.removeClass("activeFilter");
          $$("#reservationFilterValue").val("");
        } else {
          $('.reservationFilterClass').each(function (i, obj) {
            var tmpCheckClass = $$("#" + obj.id);

            if (tmpCheckClass.hasClass("activeFilter")) {
              tmpCheckClass.removeClass("activeFilter");
            }

            el.addClass("activeFilter");
          }); // kane set to filter

          $$("#reservationFilterValue").val(Type);
        }

        renderEvents();
      }

      ;
      $$('#InHouseFilter').on('click', async function () {
        FilterReservations("InHouseFilter", 'In-House');
      });
      $$('#NotAssignedFilter').on('click', async function () {
        FilterReservations("NotAssignedFilter", 'Not-Assigned');
      });
      $$('#DepartureFilter').on('click', async function () {
        FilterReservations("DepartureFilter", 'Departure');
      });
      $$('#ArrivalFilter').on('click', async function () {
        FilterReservations("ArrivalFilter", 'Arrival');
      }); //listview button

      $$('#listbutton').on('click', async () => {
        if ($$('#listbutton').hasClass("listbtnvieweanble")) {
          $$('#listbutton').removeClass('listbtnvieweanble');
          $$('#page').removeClass('page-with-subnavbar');
          $$('.subnavbar').hide();
          app.tab.show('#tab-1', false);
        } else {
          $$('#listbutton').addClass('listbtnvieweanble');
          $$('#page').addClass('page-with-subnavbar');
          $$('.subnavbar').show();
          app.tab.show('#tab-2', false);
        }

        this.$setState({}); //Update Gauges
      });
    },
    pageBeforeIn: function (e, page) {
      console.log('pageBeforeIn', page);
    },
    pageReinit: async function (e, page) {
      console.log('tabreinit', page);
    },
    tabReinit: async function (e, page) {
      console.log('tabreinit', page);
    },
    pageAfterIn: function (e, page) {
      var self = this;
      var $ = self.$;
      console.log('pageAfterIn', page);
    },
    pageBeforeOut: function (e, page) {
      console.log('pageBeforeOut', page);
    },
    pageAfterOut: function (e, page) {
      console.log('pageAfterOut', page);
    },
    pageBeforeRemove: function (e, page) {
      console.log('pageBeforeRemove', page);
    },
    tabBeforeRemove: function (e, page) {
      console.log('tabBeforeRemove', page);
    },
    tabAfterIn: function (e, page) {
      console.log('tabafterinit', page); // $$( ".page-current" ).on( 'click', ".reservationcardbtn",   function(event) {
      //   
      //   let $target = $(event.target);
      //   let $label = $target.closest('.reservationcardbtn');
      //   let resId = $label.attr("id");
      //   console.log("edw",resId);
      // });
    }
  },
  id: 'a3eed920c5',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div id=page class=page data-name=reservationspage><input hidden id=reservationFilterValue value=""> <input hidden id=reservationLastSearchDayValue value=""><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link icon-only panel-open" data-panel=left><i class="icon f7-icons if-not-md">menu</i> <i class="icon material-icons if-md">menu</i></a></div><div class="title sliding">';
      r += Template7Helpers.t.call(ctx_1, 'reservations', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=right><!-- <a href="#" id="" class="link icon-only" data-panel="">\n                  <i class="icon f7-icons if-not-md">search</i>\n                  <i class="icon material-icons if-md ">search</i>\n                </a> --> <a href=# id=listbutton class="link icon-only" data-panel=""><i class="icon f7-icons if-not-md">list</i> <i class="icon material-icons if-md">list</i> </a><a class="link icon-only searchbar-enable"><i class="icon f7-icons if-not-md">search</i> <i class="icon material-icons md-only">search</i></a></div></div><!-- Subnavbar --><div class=subnavbar style="background-color: #222933;"><div class=subnavbar-inner><span class=row style="width: 100%;display: inline-block;position: absolute;text-align: center;top: -19px;font-size: 15px;left:0;">';
      r += Template7Helpers.t.call(ctx_1, 'sortby', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span><!-- Subnavbar content, for example tabs buttons --><div class=row><div class="segmented segmented-strong" style=background-color:#40454cb8><a class="button tab-link tab-link-active sort-by-option" href=#ArrivalDate>Arrival Date</a> <a class="button tab-link sort-by-option" href=#BookingDate>Booking Date</a> <a class="button tab-link sort-by-option" href=#DepartureDate>Departure Date</a> <span class=segmented-highlight></span></div></div></div></div></div><div class="page-content reservationspage"><div class=tabs><div id=tab-1 class="tab tab-active"><div id=reservations-calendar-inline-container></div><div id=calendar-events class="list no-margin no-hairlines no-safe-area-left"><div class=card style="height: 85px;"><div class="card-content card-content-padding takis"><div class=row style="text-align: center;"><div class="col-25 reservationFilterClass" style="display: grid;" id=ArrivalFilter><span>';
      r += Template7Helpers.t.call(ctx_1, 'arrivals', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span> ';
      r += c(ctx_1.Inhouseinfo.Arrivals, ctx_1);
      r += '</div><div class="col-25 reservationFilterClass" style="display: grid;" id=DepartureFilter><span>';
      r += Template7Helpers.t.call(ctx_1, 'departures', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span> ';
      r += c(ctx_1.Inhouseinfo.Departures, ctx_1);
      r += '</div><div class="col-25 reservationFilterClass" style="display: grid;" id=InHouseFilter><span>';
      r += Template7Helpers.t.call(ctx_1, 'inhouse', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span> ';
      r += c(ctx_1.Inhouseinfo.InHouse, ctx_1);
      r += '</div><div class="col-25 reservationFilterClass" style="display: grid;" id=NotAssignedFilter><span>NA</span> ';
      r += c(ctx_1.Inhouseinfo.NotAssigned, ctx_1);
      r += '</div></div></div></div><ul>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.eventItems, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="card reservationcardbtn" @click=openAlert(';
          r += c(ctx_2.ReservationCode, ctx_2);
          r += ');><div class="card-content card-content-padding"><li class=item-content style="display: block;padding-top: 5px;padding-bottom: 5px;"><div class=event-color style="background-color: ';
          r += c(ctx_2.color, ctx_2);
          r += '"></div><div class=row><div style="font-weight:600;font-size: 15px;">';
          r += c(ctx_2.CustomerFirstName, ctx_2);
          r += ' ';
          r += c(ctx_2.CustomerLastName, ctx_2);
          r += ' <span class="badge color-blue Reservation">';
          r += c(ctx_2.Source, ctx_2);
          r += '</span></div><div class="Price totalpriceroom" id=roomNumberID>';
          r += c(ctx_2.RoomName, ctx_2);
          r += '</div></div><div class=row><div class="col-70 reservcode" style=display:flex; id=';
          r += c(ctx_2.ReservationID, ctx_2);
          r += '>Res. cod. ';
          r += c(ctx_2.ReservationCode, ctx_2);
          r += '</div>';
          r += Template7Helpers.if.call(ctx_2, ctx_2.hasCommunicator, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class="col-30 communicator-alert" style="display: flex;align-items: center;justify-content: flex-end;" @click="openConversation(';
              r += c(ctx_3.ConversationID, ctx_3);
              r += ', ';
              r += c(ctx_3.ReservationID, ctx_3);
              r += ');"><div style="position: relative;"><div><svg xmlns=http://www.w3.org/2000/svg x=0px y=0px width=20 height=20 viewBox="0 0 50 50"><path d="M 25 4.0625 C 12.414063 4.0625 2.0625 12.925781 2.0625 24 C 2.0625 30.425781 5.625 36.09375 11 39.71875 C 10.992188 39.933594 11 40.265625 10.71875 41.3125 C 10.371094 42.605469 9.683594 44.4375 8.25 46.46875 L 7.21875 47.90625 L 9 47.9375 C 15.175781 47.964844 18.753906 43.90625 19.3125 43.25 C 21.136719 43.65625 23.035156 43.9375 25 43.9375 C 37.582031 43.9375 47.9375 35.074219 47.9375 24 C 47.9375 12.925781 37.582031 4.0625 25 4.0625 Z M 25 5.9375 C 36.714844 5.9375 46.0625 14.089844 46.0625 24 C 46.0625 33.910156 36.714844 42.0625 25 42.0625 C 22.996094 42.0625 21.050781 41.820313 19.21875 41.375 L 18.65625 41.25 L 18.28125 41.71875 C 18.28125 41.71875 15.390625 44.976563 10.78125 45.75 C 11.613281 44.257813 12.246094 42.871094 12.53125 41.8125 C 12.929688 40.332031 12.9375 39.3125 12.9375 39.3125 L 12.9375 38.8125 L 12.5 38.53125 C 7.273438 35.21875 3.9375 29.941406 3.9375 24 C 3.9375 14.089844 13.28125 5.9375 25 5.9375 Z"></path></svg></div>';
              r += Template7Helpers.if.call(ctx_3, ctx_3.NewMessages, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' <span class="badge color-red communicator-badge">';
                  r += c(ctx_4.NewMessages, ctx_4);
                  r += ' </span>';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div><div class=row><div class="col-100 reservcode" style=display:flex;>';
          r += c(ctx_2.RoomTypeStr, ctx_2);
          r += ' (';
          r += c(ctx_2.TotalPrice, ctx_2);
          r += ' ';
          r += c(ctx_2.Currency, ctx_2);
          r += ')</div></div><div class=row><div class="col-100 reservcode">';
          r += c(ctx_2.Nights, ctx_2);
          r += ' Nights - ';
          r += c(ctx_2.TotalGuests, ctx_2);
          r += ' Guests - ';
          r += c(ctx_2.NumberOfRooms, ctx_2);
          r += ' Rooms<!-- ';
          r += c(ctx_2.TotalPrice, ctx_2);
          r += ' €\n                        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.IsPaid, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <span style="float:right;">\n                          (is paid)\n                        </span>\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' --></div></div><!-- <div class="row">\n                      <div class="col-100">\n                        ';
          r += c(ctx_2.RoomName, ctx_2);
          r += ', ';
          r += c(ctx_2.RoomTypeStr, ctx_2);
          r += '\n                      </div>\n                    </div>\n                    <div class="row">\n                      <div class="col-100">\n                        ';
          r += c(ctx_2.Nights, ctx_2);
          r += ' Night - ';
          r += c(ctx_2.TotalGuests, ctx_2);
          r += ' guests - ';
          r += c(ctx_2.NumberOfRooms, ctx_2);
          r += ' Room\n                      </div>\n                    </div> --></li></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</ul></div></div><div id=tab-2 class=tab><div class=tabs><div class="view tab tab-active" id=ArrivalDate>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.GroupCheckinReservations, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="block-title activity">';
          r += Template7Helpers.FormatDate.call(ctx_2, 1, ctx_2.ReservationCheckInStr, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.Reservations, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=card><div class="card-content card-content-padding reservationcard"><div class=row><div class=col-100><b>';
              r += Template7Helpers.t.call(ctx_3, 'newreservation', {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</b></div></div><div class="event-color date-sort-color" style="background-color: ';
              r += c(ctx_3.color, ctx_3);
              r += '"></div><div class=row><div class=col-70 style="font-weight:600;font-size: 15px;">';
              r += c(ctx_3.CustomerFirstName, ctx_3);
              r += ' ';
              r += c(ctx_3.CustomerLastName, ctx_3);
              r += ' <span class="badge color-blue Reservation">';
              r += c(ctx_3.Source, ctx_3);
              r += '</span></div><div class="col-30 Price totalpriceroom" id=roomNumberID>';
              r += c(ctx_3.RoomName, ctx_3);
              r += '</div></div><div class=row><div class="col-100 reservcode" style=display:flex; id=';
              r += c(ctx_3.ReservationID, ctx_3);
              r += '>Res. cod. ';
              r += c(ctx_3.ReservationCode, ctx_3);
              r += '</div></div><div class=row><div class="col-100 reservcode" style=display:flex;>';
              r += c(ctx_3.RoomTypeStr, ctx_3);
              r += ' (';
              r += c(ctx_3.TotalPrice, ctx_3);
              r += ' ';
              r += c(ctx_3.Currency, ctx_3);
              r += ')</div></div><div class=row><div class="col-100 reservcode">';
              r += c(ctx_3.Nights, ctx_3);
              r += ' Nights - ';
              r += c(ctx_3.TotalGuests, ctx_3);
              r += ' Guests - ';
              r += c(ctx_3.NumberOfRooms, ctx_3);
              r += ' Rooms<!-- ';
              r += c(ctx_3.TotalPrice, ctx_3);
              r += ' €\n                      ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.IsPaid, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      <span style="float:right;">\n                        (is paid)\n                      </span>\n                      ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' --></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class="view tab" id=BookingDate><!--All  reservations--> ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.GroupReservations, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="block-title activity">';
          r += Template7Helpers.FormatDate.call(ctx_2, 1, ctx_2.ReservationBookingDayStr, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.Reservations, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=card><div class="card-content card-content-padding reservationcard"><div class=row><div class=col-100><b>';
              r += Template7Helpers.t.call(ctx_3, 'newreservation', {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</b></div></div><div class="event-color date-sort-color" style="background-color: ';
              r += c(ctx_3.color, ctx_3);
              r += '"></div><div class=row><div class=col-70 style="font-weight:600;font-size: 15px;">';
              r += c(ctx_3.CustomerFirstName, ctx_3);
              r += ' ';
              r += c(ctx_3.CustomerLastName, ctx_3);
              r += ' <span class="badge color-blue Reservation">';
              r += c(ctx_3.Source, ctx_3);
              r += '</span></div><div class="col-30 Price totalpriceroom" id=roomNumberID>';
              r += c(ctx_3.RoomName, ctx_3);
              r += '</div></div><div class=row><div class="col-100 reservcode" style=display:flex; id=';
              r += c(ctx_3.ReservationID, ctx_3);
              r += '>Res. cod. ';
              r += c(ctx_3.ReservationCode, ctx_3);
              r += '</div></div><div class=row><div class="col-100 reservcode" style=display:flex;>';
              r += c(ctx_3.RoomTypeStr, ctx_3);
              r += ' (';
              r += c(ctx_3.TotalPrice, ctx_3);
              r += ' ';
              r += c(ctx_3.Currency, ctx_3);
              r += ')</div></div><div class=row><div class="col-100 reservcode">';
              r += c(ctx_3.Nights, ctx_3);
              r += ' Nights - ';
              r += c(ctx_3.TotalGuests, ctx_3);
              r += ' Guests - ';
              r += c(ctx_3.NumberOfRooms, ctx_3);
              r += ' Rooms<!-- ';
              r += c(ctx_3.TotalPrice, ctx_3);
              r += ' €\n                      ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.IsPaid, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      <span style="float:right;">\n                        (is paid)\n                      </span>\n                      ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' --></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class="view tab" id=DepartureDate><!--All  reservations--> ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.GroupCheckOuteservations, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="block-title activity">';
          r += Template7Helpers.FormatDate.call(ctx_2, 1, ctx_2.ReservationCheckOutStr, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.Reservations, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=card><div class="card-content card-content-padding reservationcard"><div class=row><div class=col-100><b>';
              r += Template7Helpers.t.call(ctx_3, 'newreservation', {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</b></div></div><div class="event-color date-sort-color" style="background-color: ';
              r += c(ctx_3.color, ctx_3);
              r += '"></div><div class=row><div class=col-70 style="font-weight:600;font-size: 15px;">';
              r += c(ctx_3.CustomerFirstName, ctx_3);
              r += ' ';
              r += c(ctx_3.CustomerLastName, ctx_3);
              r += ' <span class="badge color-blue Reservation">';
              r += c(ctx_3.Source, ctx_3);
              r += '</span></div><div class="col-30 Price totalpriceroom" id=roomNumberID>';
              r += c(ctx_3.RoomName, ctx_3);
              r += '</div></div><div class=row><div class="col-100 reservcode" style=display:flex; id=';
              r += c(ctx_3.ReservationID, ctx_3);
              r += '>Res. cod. ';
              r += c(ctx_3.ReservationCode, ctx_3);
              r += '</div></div><div class=row><div class="col-100 reservcode" style=display:flex;>';
              r += c(ctx_3.RoomTypeStr, ctx_3);
              r += ' (';
              r += c(ctx_3.TotalPrice, ctx_3);
              r += ' ';
              r += c(ctx_3.Currency, ctx_3);
              r += ')</div></div><div class=row><div class="col-100 reservcode">';
              r += c(ctx_3.Nights, ctx_3);
              r += ' Nights - ';
              r += c(ctx_3.TotalGuests, ctx_3);
              r += ' Guests - ';
              r += c(ctx_3.NumberOfRooms, ctx_3);
              r += ' Rooms<!-- ';
              r += c(ctx_3.TotalPrice, ctx_3);
              r += ' €\n                      ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.IsPaid, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      <span style="float:right;">\n                        (is paid)\n                      </span>\n                      ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' --></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
  .communicator-badge {
    border-radius: 10px !important;
    position: absolute;
    top: -4px;
    right: -8px;
    font-size: 10px;
    height: 14px;
    min-width: 0px;
  }

  .sort-by-option {
    font-size: 11px;
  }

  .reservationFilterClass>span {
    font-size: 12px;
  }

  .activeFilter {
    border: 1px solid #383838;
    border-radius: 15px;
    font-size: 18px;
    background: #f3f3f3;
  }

  .reservationspage {
    background-color: #F7F7F7;
  }

  a.link:before {
    content: '';
    width: 100% !important;

  }

  .listbtnvieweanble>i {
    background-color: #F7F7F7;
    color: #222933;
    border-radius: 3px;
  }

  #calendar,
  #calendar-events {
    height: 50%;
    box-sizing: border-box;
  }

  #calendar .calendar {
    height: 100%;
  }

  #calendar-events ul {
    height: 100%;
    overflow: auto;
  }

  #calendar-events .event-color {
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 100%;
  }

  .date-sort-color {
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 100%;
  }

  .totalpriceroom {
    color: black;
    white-space: nowrap;
    font-size: 14px;
  }

  /* @media (orientation: landscape) {
    #calendar {
      float: left;
    }

    #calendar,
    #calendar-events {
      height: 100%;
    }

    #calendar,
    #calendar-events {
      width: 50%;
    }

    #calendar-events {
      margin-left: 50% !important;
      border-left: 1px solid #eee;
    }

    .theme-dark #calendar-events {
      border-left-color: #282828;
    }
  } */
`,
  styleScoped: false
};
    